class ProductAccordionsModule {
  constructor(controller) {
    this.controller = controller;
    this.accordions = controller.queryAll('[data-product-accordion]');
    this.itemObservers = [];

    if (!this.accordions.length) return;

    this.init();
  }

  init() {
    this.accordions.forEach((accordion) => {
      accordion.querySelectorAll('.product-accordion__item').forEach((item) => {
        this.observeItem(item);
        this.setAccordionHeight(item);
      });

      accordion.querySelectorAll('[data-accordion-header]').forEach((header) => {
        header.addEventListener('click', () => {
          const item = header.closest('.product-accordion__item');
          if (!item) return;

          const isActive = item.classList.contains('product-accordion__item--active');
          accordion.querySelectorAll('.product-accordion__item').forEach((accordionItem) => {
            accordionItem.classList.remove('product-accordion__item--active');
            this.setAccordionHeight(accordionItem);
          });

          if (!isActive) {
            item.classList.add('product-accordion__item--active');
            this.setAccordionHeight(item);
          }
        });
      });
    });

    window.addEventListener('resize', () => {
      this.accordions.forEach((accordion) => {
        accordion.querySelectorAll('.product-accordion__item').forEach((item) => {
          this.setAccordionHeight(item);
        });
      });
    });
  }

  observeItem(item) {
    const classObserver = new MutationObserver(() => {
      this.setAccordionHeight(item);
    });

    classObserver.observe(item, {
      attributes: true,
      attributeFilter: ['class']
    });

    this.itemObservers.push(classObserver);

    const content = item.querySelector('[data-accordion-content]');
    if (!content) return;

    item.querySelectorAll('img, video, iframe').forEach((media) => {
      media.addEventListener('load', () => this.setAccordionHeight(item), { once: true });
      media.addEventListener('loadedmetadata', () => this.setAccordionHeight(item), { once: true });
    });

    if (typeof ResizeObserver === 'undefined') return;

    const resizeObserver = new ResizeObserver(() => {
      this.setAccordionHeight(item);
    });

    resizeObserver.observe(item.querySelector('.product-accordion__body') || content);
    this.itemObservers.push(resizeObserver);
  }

  setAccordionHeight(item) {
    const content = item.querySelector('[data-accordion-content]');
    if (!content) return;

    if (item.classList.contains('product-accordion__item--active')) {
      content.style.setProperty('--accordion-content-height', `${content.scrollHeight}px`);
      return;
    }

    content.style.removeProperty('--accordion-content-height');
  }
}

window.HerbiProductSection.registerModule('accordions', (controller) => {
  return new ProductAccordionsModule(controller);
});
